/** Lower-level utils for animation. */
/**
 * When animating a React component from state, this should be called
 * in between state changes to ensure the browser repaints the component
 * in each animation state.
 *
 * Without doing so the browser may not paint subsequent states that
 * follow one another very rapidly, resulting in CSS transitions
 * not triggering.
 *
 * There may be cases in which this function is not necessary. For example,
 * - if `await sleep()` is called or,
 * - if using the `React.useEffect` hook, that is fired after layout and paint.
 *
 * However, https://codesandbox.io/s/delicate-river-s1e0g shows that these
 * cannot always be relied upon (tested on Chrome 80).
 *
 * Using nested `requestAnimationFrame` calls is suggested in these articles:
 *
 * https://github.com/reactjs/react-transition-group/pull/13#issuecomment-278354266
 * https://muffinman.io/react-rerender-in-component-did-mount/
 */
var ensureComponentPainted = function () {
    return new Promise(function (resolve) {
        requestAnimationFrame(function () { return requestAnimationFrame(resolve); });
    });
};

export { ensureComponentPainted };
